import { useTranslation } from "react-i18next"

import HERO_PREVIEW_IMAGE from "@/assets/imgs/app-home.png"
import { cn } from "@/shared/utils/cn"

import {
  BTN_GHOST,
  BTN_PRIMARY,
  CONTAINER,
  EYEBROW,
  H1,
  LEAD,
} from "../components/styles"
import { ANCHORS, DOWNLOAD_PAGE_URL } from "../site-config"

/** 首屏：一句话定位 + 资质速览 + App 实机截图 */
export function HeroSection() {
  const { t } = useTranslation()

  // 资质速览（运营主体 / 注册号 / 币种 / 备案）待真实信息填入后再启用，
  // 数据取自 site-config.ts 的 SITE，区块结构见下方注释掉的 <dl>
  // const facts = [
  //   { label: t("official_fact_entity_label"), value: SITE.companyName },
  //   { label: t("official_fact_reg_label"), value: SITE.regNo },
  //   { label: t("official_fact_currency_label"), value: SITE.currency },
  //   { label: t("official_fact_license_label"), value: SITE.licenseNo },
  // ]

  return (
    <section
      id={ANCHORS.download}
      className="scroll-mt-[68px] bg-gradient-to-b from-primary-50 to-white py-12 sm:py-16"
    >
      <div
        className={`${CONTAINER} grid items-center gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14`}
      >
        <div>
          <p className={EYEBROW}>{t("official_hero_eyebrow")}</p>
          <h1 className={H1}>{t("official_hero_title")}</h1>
          <p className={`mt-4 ${LEAD}`}>{t("official_hero_lead")}</p>

          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={DOWNLOAD_PAGE_URL}
              className={cn(BTN_PRIMARY, "hover:bg-primary/60")}
            >
              {t("official_hero_btn_download")}
            </a>
            <a href={`#${ANCHORS.refund}`} className={BTN_GHOST}>
              {t("official_hero_btn_refund")}
            </a>
          </div>
        </div>

        <figure className="m-0">
          <div className="mx-auto h-[420px] max-w-[320px] overflow-hidden rounded-t-[34px] sm:h-[520px] sm:max-w-[360px] lg:max-w-none">
            <img
              src={HERO_PREVIEW_IMAGE}
              alt={t("official_hero_preview_alt")}
              loading="lazy"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <figcaption className="mt-2.5 text-center text-[13px] text-ink-tertiary">
            {t("official_hero_preview_caption")}
          </figcaption>
        </figure>
      </div>
    </section>
  )
}
